import React, { Component } from 'react';
import qs from 'query-string';
import { Redirect } from 'react-router-dom';
import { injectIntl, FormattedMessage } from 'react-intl';
import compose from 'lodash/fp/compose';
import withWidth from '@material-ui/core/withWidth';
import { Typography } from '@material-ui/core';
import { Button } from '@lavu-pos/lavu-react-components';


import {
	Spacer,
	intlShape
} from 'modules/utils';

import { StyledForm, StyledFormMessage } from './styles';

class RefreshPage extends Component {
	static propTypes = {
		intl: intlShape,
	};

	handleRefresh = () => {
		var rnd = Math.floor(Math.random() * 100000);
		setTimeout(function(){window.location.href = "/login?q="+rnd},1000);
	};

	render() {

		const { intl } = this.props;

		const { code, ...params } = qs.parse(
			window.location.search
		);

		let errorMessage ='';
		if(code)
		{
			errorMessage = intl.formatMessage({ id: `hubqlErrors.${code}` });
		} else {
			var rnd = Math.floor(Math.random() * 100000);
			var redirectUrl = "/login?q="+rnd;
			return <Redirect to={redirectUrl} />;
		}

		return (
					<StyledForm>
						{!errorMessage && <Spacer height={20} />}
						{errorMessage && (
							<StyledFormMessage>
								<Typography
									component="span"
									className="login-form-text login-form-error"
								>
									{errorMessage}
								</Typography>
							</StyledFormMessage>
						)}
						<Button
							disabled={false}
							type="submit"
							kind="success"
							fluid
							onClick={this.handleRefresh}
						>
							<FormattedMessage id="commonStrings.refreshPage" />
						</Button>
					</StyledForm>
		);
	}
}

export default compose(
	injectIntl,
	withWidth(),
)(RefreshPage);
